import clsx from 'clsx';
import { useMemo } from 'react';
import Slider from './Slider';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const WidgetsGallery = _ref => {
  let {
    className = '',
    isLoaded,
    widgets,
    filters
  } = _ref;
  // Get "Popular" widgets
  const popularWidgets = useMemo(() => widgets.sort((a, b) => {
    var _b$stats, _a$stats;

    return (((_b$stats = b.stats) === null || _b$stats === void 0 ? void 0 : _b$stats.cloned) || 0) - (((_a$stats = a.stats) === null || _a$stats === void 0 ? void 0 : _a$stats.cloned) || 0);
  }).slice(0, 6), [widgets]); // Get "Newest" widgets

  const newestWidgets = useMemo(() => widgets.sort((a, b) => b.updatedAt - a.updatedAt).slice(0, 6), [widgets]); // Get widgets by "Tags"

  const tagsWidgets = useMemo(() => filters.map(tag => ({
    title: tag.name,
    widgets: widgets.filter(widget => {
      var _widget$tags;

      return widget === null || widget === void 0 ? void 0 : (_widget$tags = widget.tags) === null || _widget$tags === void 0 ? void 0 : _widget$tags.includes(tag.name);
    }).sort((a, b) => {
      var _b$stats2, _a$stats2;

      return (((_b$stats2 = b.stats) === null || _b$stats2 === void 0 ? void 0 : _b$stats2.cloned) || 0) - (((_a$stats2 = a.stats) === null || _a$stats2 === void 0 ? void 0 : _a$stats2.cloned) || 0);
    })
  })), [filters, widgets]);
  return /*#__PURE__*/_jsxs("section", {
    className: clsx(styles.container, className),
    children: [/*#__PURE__*/_jsx(Slider, {
      title: "Popular",
      widgets: popularWidgets,
      anchor: "popular",
      isLoaded: isLoaded
    }), /*#__PURE__*/_jsx(Slider, {
      title: "Newest",
      widgets: newestWidgets,
      anchor: "newest",
      isLoaded: isLoaded
    }), tagsWidgets === null || tagsWidgets === void 0 ? void 0 : tagsWidgets.map(collection => /*#__PURE__*/_jsx(Slider, {
      title: collection.title,
      widgets: collection.widgets,
      anchor: collection.title,
      isLoaded: isLoaded
    }, `tags-collection-${collection.title}`))]
  });
};
export default WidgetsGallery;